var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("销售属性")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "Box" }, [
        _c("div", { staticClass: "table_tab" }, [
          _c(
            "div",
            { staticClass: "inquiry" },
            [
              _vm._m(0),
              _c("div", { staticClass: "headerTitle" }, [_vm._v("数据筛选")]),
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    inline: true,
                    model: _vm.queryForm,
                    "label-width": "",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "规格名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入类目名称",
                          clearable: "",
                          maxlength: 20,
                        },
                        model: {
                          value: _vm.queryForm.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "规格编号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入编号",
                          clearable: "",
                          oninput: "value=value.replace(/[^0-9.]/g,'')",
                        },
                        model: {
                          value: _vm.queryForm.specNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm,
                              "specNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.specNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属类目：" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          clearable: "",
                          options: _vm.categoryOptions,
                          props: {
                            label: "categoryName",
                            value: "id",
                            checkStrictly: true,
                          },
                          filterable: "",
                        },
                        on: { change: _vm.handleChangeSearch },
                        model: {
                          value: _vm.queryForm.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "categoryId", $$v)
                          },
                          expression: "queryForm.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.selectState },
                          model: {
                            value: _vm.queryForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "status", $$v)
                            },
                            expression: "queryForm.status",
                          },
                        },
                        _vm._l(_vm.dictionaries.enable_status, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.searchEvent()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.searchEvent.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.reset()
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "inquiryTab" }, [
            _c(
              "div",
              { staticClass: "inquiryTab_header" },
              [
                _c("div", { staticClass: "tabTitle" }, [_vm._v("列表数据")]),
                _vm.parArray.indexOf("addMarketCode") != -1
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "120px",
                          height: "36px",
                          "line-height": "11px",
                        },
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addClassify("add")
                          },
                        },
                      },
                      [_vm._v("新 增")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData.list,
                      "header-cell-style": { background: "#f8f8f8" },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "规格编号", prop: "specNo" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.specNo) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "规格名称", prop: "name" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "所属类目", prop: "categoryNameList" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "子规格", prop: "itemCount" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: props.row.list,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        cursor: "pointer",
                                      },
                                    },
                                    [_vm._v(_vm._s(props.row.itemCount))]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态", prop: "status" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "p",
                                {
                                  class:
                                    props.row.status == 1 ? "green" : "red",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(props.row.statusLabel) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "最后编辑时间", prop: "updatedTime" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", fixed: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              props.row.status == 2 &&
                              _vm.parArray.indexOf("enableMarket") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.setState(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 启用 ")]
                                  )
                                : _vm._e(),
                              props.row.status == 1 &&
                              _vm.parArray.indexOf("forbiddenMarket") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.setState(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 禁用 ")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("editMarketCode") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.antiShake(
                                            "edit",
                                            props.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 编辑 ")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("copyProperty") != -1
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "btnp",
                                      on: {
                                        click: function ($event) {
                                          return _vm.copy("copy", props.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 复制 ")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.pageNo,
                "page-sizes": [10, 20, 50, 100, 200],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.tableData.totalNum,
                "prev-text": "上一页",
                "next-text": "下一页",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            "close-on-click-modal": false,
            "append-to-body": "",
            visible: _vm.dialog.visible,
            width: "700px",
            "before-close": _vm.handleCloseAddClassify,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规格编号：", prop: "specNo" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请输入规格编号",
                      maxLength: 20,
                      type: "text",
                    },
                    on: {
                      input: (v) => (_vm.form.specNo = v.replace(/[^\d]/g, "")),
                    },
                    model: {
                      value: _vm.form.specNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "specNo", $$v)
                      },
                      expression: "form.specNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "规格名称：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入规格名称",
                      maxlength: 20,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属类目：", prop: "categoryIdList" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请选择三级类目",
                      options: _vm.categoryOptions,
                      props: {
                        label: "categoryName",
                        value: "id",
                        multiple: true,
                      },
                      "collapse-tags": "",
                      clearable: "",
                    },
                    on: { change: _vm.handleCategory },
                    model: {
                      value: _vm.form.categoryIdList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "categoryIdList", $$v)
                      },
                      expression: "form.categoryIdList",
                    },
                  }),
                ],
                1
              ),
              _c("span", { staticStyle: { "margin-left": "100px" } }, [
                _vm._v("规格值"),
                _c(
                  "span",
                  { staticStyle: { color: "#4168e7", "padding-left": "10px" } },
                  [_vm._v("(已选" + _vm._s(_vm.dynamicTags.length) + ")")]
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { prop: "list", label: "商品规格：" } },
                [
                  _vm._l(_vm.dynamicTags, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag,
                        attrs: { closable: "", "disable-transitions": false },
                        on: {
                          close: function ($event) {
                            return _vm.handleClose(tag)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(tag) + " ")]
                    )
                  }),
                  _vm.inputVisible
                    ? _c("el-input", {
                        ref: "saveTagInput",
                        staticClass: "input-new-tag",
                        attrs: { size: "small" },
                        on: { blur: _vm.handleInputConfirm },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.handleInputConfirm.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.form.itemList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "itemList", $$v)
                          },
                          expression: "form.itemList",
                        },
                      })
                    : _c(
                        "el-button",
                        {
                          staticClass: "button-new-tag",
                          attrs: { size: "small" },
                          on: { click: _vm.showInput },
                        },
                        [_vm._v("+ 继续添加")]
                      ),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    _vm._l(
                      _vm.dictionaries.enable_status,
                      function (item, index) {
                        return _c(
                          "el-radio",
                          { key: index, attrs: { label: item.dictId } },
                          [_vm._v(_vm._s(item.dictName))]
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right", "margin-bottom": "25px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "dialogbtn",
                      on: {
                        click: function ($event) {
                          _vm.dialog.visible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "dialogbtntoo",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.classifyAdd("form")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerbox" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title_left" }),
        _vm._v(" 销售属性 "),
      ]),
      _c("div", { staticClass: "headerbox_right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }